<template>
  <container
    :subHeaderTitle="serviceType"
    subHeaderText="휴대폰으로 전송된 인증번호를 입력해주세요."
    subHeaderAlign="center"
  >
    <section class="form-area mb-180">
      <v-container class="py-0">
        <v-row justify="center">
          <v-col cols="12" md="4" sm="6">
            <v-form v-model="valid" ref="form" onsubmit="return false;">
              <p>인증번호</p>
              <div class="d-flex">
                <v-text-field
                  v-if="teleCoCd == '3'"
                  ref="certNum"
                  label="인증번호 입력"
                  mask="########"
                  :rules="rules.certNumLgTRules"
                  v-model="certNum"
                  v-bind:suffix="countdown"
                  required
                  solo
                />
                <v-text-field
                  v-else
                  ref="certNum"
                  label="인증번호 입력"
                  mask="#####"
                  :rules="rules.certNumRules"
                  v-model="certNum"
                  :suffix="countdown"
                  required
                  solo
                />
                <v-btn large depressed class="ml-2 resend" @click.stop="sendSmsCert()">재전송</v-btn>
              </div>
              <div class="pl-5 mt-2 mb-12">
                <ul>
                  <li>인증번호는 3분 이내에 입력하셔야 합니다.</li>
                  <li>인증시간이 초과하면 재전송하여 인증하시기 바랍니다.</li>
                </ul>
              </div>
              <div>
                <v-btn class="submit" rounded block large depressed color="primary" @click.stop="submit()">확인</v-btn>
              </div>
              <div class="text-center mt-3">
                <v-btn class="back" text rounded @click.stop="$router.go(-1)">취소</v-btn>
              </div>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- 인증번호 인증 실패 -->
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline"></v-card-title>
        <v-card-text style="text-align:center;">인증번호를 확인하세요.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.native="dialog = false">확인</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 처리 프로그레스-->
    <v-dialog v-model="progressDialog" persistent max-width="100">
      <v-card>
        <v-progress-linear color="primary" indeterminate></v-progress-linear>
      </v-card>
    </v-dialog>

    <!-- 처리결과 다이얼로그 -->
    <v-dialog v-model="resultDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline"></v-card-title>
        <v-card-text style="text-align:center;">정상적으로 처리되지 않았습니다.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.stop="goNext()">확인</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- router Param 없을때 -->
    <v-dialog v-model="returnDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline"></v-card-title>
        <v-card-text style="text-align:center;">정상적인 접근이 아닙니다.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.stop="goReturn()">확인</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 시간제한 지났을때 -->
    <v-dialog v-model="countDownOverDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline"></v-card-title>
        <v-card-text style="text-align:center;"
          >인증시간이 초과했습니다.<br />
          재전송 버튼을 눌러주시기 바랍니다.</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.stop="countDownOverDialog = !countDownOverDialog">확인</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </container>
</template>

<style lang="scss" scoped>
@import "@/styles/cscenter";
</style>

<script>
import Container from "@/pages/container/index.vue";

export default {
  name: "SafebillingCert",
  components: {
    Container
  },
  data() {
    return {
      valid: false,
      type: "",
      teleCoCd: "1",
      cellTelNo: "",
      birth: "",
      genCd: "",
      name: "",
      certNum: "",
      prdtNo: "A001",
      agreeYn: false,
      formHasErrors: false, // validation
      dialog: false,
      progressDialog: false,
      resultDialog: false,
      returnDialog: false,
      countDownOverDialog: false,
      rules: {
        requiredCertNum: (value) => !!value || "인증번호를 입력하세요.",
        certNumRules: [(v) => !!v || "인증번호를 입력하세요.", (v) => (v && v.length >= 5 && /([0-9]{5})$/.test(v)) || "인증번호가 정확하지 않습니다."],
        certNumLgTRules: [(v) => !!v || "인증번호를 입력하세요.", (v) => (v && (v.length >= 8 || v.length == 5) && /([0-9]{5})|([0-9]{8})$/.test(v)) || "인증번호가 정확하지 않습니다."]
      },
      //timer
      countdown: "3:00",
      endTime: "",
      hours: "",
      mins: "",
      msLeft: "",
      time: ""
    };
  },
  computed: {
    form() {
      return {
        certNum: this.certNum
      };
    },
    serviceType() {
      return this.type === "join" ? "세이프빌링<br /><b>가입하기</b>" : "세이프빌링<br /><b>해지하기</b>";
    }
  },
  created() {
    this.type = this.$route.params.type;
    // this.teleCoCd = this.$route.params.teleCoCd;
    this.cellTelNo = this.$route.params.cellTelNo;
    this.birth = this.$route.params.birth;
    this.genCd = this.$route.params.genCd;
    this.name = this.$route.params.name;
    // this.agreeYn = this.$route.params.agreeYn;

    if (this.type == undefined) {
      this.returnDialog = true;
    }
  },
  mounted() {
    this.sendSmsCert();
  },
  methods: {
    sendSmsCert() {
      this.axios
        .post("/rest/callSafebilling", {
          actionType: "send",
          cellTelNo: this.cellTelNo,
          name: this.name,
          birth: this.birth,
          genCd: this.genCd
        })
        .then((result) => {
          this.posts = result.data;
          this.countdowns("countdown", 3, 0);
        })
        .catch((result) => {});
    },
    submit() {
      this.$refs.form.validate();

      if (!this.valid) {
        return false;
      }
      this.progressDialog = true;

      if (this.countdown === "0:00") {
        this.progressDialog = false;
        this.countDownOverDialog = true;
        return false;
      }

      this.axios
        .post("/rest/callSafebilling", {
          actionType: this.type,
          cellTelNo: this.cellTelNo,
          birth: this.birth,
          genCd: this.genCd,
          name: this.name,
          certNum: this.certNum
        })
        .then((result) => {
          this.progressDialog = false;
          if (result.data.isSucceed) {
            this.$router.push({
              name: "SafebillingResult",
              params: { type: this.type, result: "SUCCESS" }
            });
          } else if (result.data.errorCode === "E001") {
            this.dialog = true;
          } else {
            this.goNext();
          }
        })
        .catch((result) => {
          this.progressDialog = false;
          this.goNext();
        });
    },
    goNext() {
      this.resultDialog = false;
      this.$router.push({ name: "SafebillingResult", params: { type: this.type, result: "FAIL" } });
    },
    goReturn() {
      this.$router.push({ name: "SafebillingCs" });
    },
    countdowns(elementName, minutes, seconds) {
      this.minutes = minutes;
      this.seconds = seconds;
      this.endTime = +new Date() + 1000 * (60 * this.minutes + this.seconds) + 500;
      this.updateTimer();
    },
    updateTimer() {
      this.msLeft = this.endTime - +new Date();
      if (this.msLeft < 1000) {
        this.countdown = "0:00";
      } else {
        this.time = new Date(this.msLeft);
        this.hours = this.time.getUTCHours();
        this.mins = this.time.getUTCMinutes();
        this.countdown = (this.hours ? this.hours + ":" + this.twoDigits(this.mins) : this.mins) + ":" + this.twoDigits(this.time.getUTCSeconds());
        setTimeout(this.updateTimer, this.time.getUTCMilliseconds() + 500);
      }
    },
    twoDigits(n) {
      return n <= 9 ? "0" + n : n;
    }
  }
};
</script>
